<template>
  <v-dialog :value="value" max-width="900px" @input="$emit('input', $event)">
    <v-card v-if="item" class="ol-prev">
      <v-card-title class="headline green white--text ol-prev__titulo">
        <span class="ol-prev__titulo-nome">{{ item.nome }}</span>
        <v-icon color="white">{{ iconeTitulo }}</v-icon>
      </v-card-title>
      <div class="ol-prev__midia" :class="{ 'ol-prev__midia--doc': item.tipo === 'documento' }">
        <!-- v-if com value: fechar destrói o <video> e para o som -->
        <img v-if="value && item.tipo === 'imagem'" :src="item.url" :alt="item.nome">
        <video
          v-else-if="value && item.tipo === 'video'"
          :src="item.url"
          controls
          autoplay
          playsinline
        ></video>
        <div v-else-if="item.tipo === 'documento'" class="ol-prev__doc">
          <v-icon size="72" color="blue-grey">{{ icone }}</v-icon>
          <span>Sem pré-visualização para este tipo de arquivo.</span>
        </div>
      </div>

      <div class="ol-prev__info">{{ meta }}</div>

      <v-card-actions class="ol-prev__acoes">
        <v-btn small depressed color="red" class="white--text" @click="$emit('remover')">
          <v-icon left small>mdi-delete</v-icon>Excluir
        </v-btn>
        <span class="ol-prev__espaco"></span>
        <v-btn v-if="item.url && item.tipo === 'documento'" small text color="blue-grey" :href="item.url" target="_blank" rel="noopener">
          Abrir
        </v-btn>
        <v-btn small depressed color="blue-grey" class="white--text" @click="$emit('input', false)">Voltar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { extensao, formatarTamanho, formatarTempo } from '../../utils/midia';

export default {
  name: 'MidiaPreview',

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    // { url, tipo: 'imagem'|'video'|'documento', nome, tamanho, duracao, servidor }
    item: {
      type: Object,
      default: null,
    },
  },

  computed: {
    iconeTitulo() {
      if (!this.item) return '';
      if (this.item.tipo === 'imagem') return 'mdi-image';
      if (this.item.tipo === 'video') return 'mdi-video';
      return this.icone;
    },
    icone() {
      const ext = extensao(this.item && this.item.nome);
      if (ext === 'pdf') return 'mdi-file-pdf-box';
      if (['doc', 'docx', 'odt'].includes(ext)) return 'mdi-file-word-box';
      if (['xls', 'xlsx', 'ods'].includes(ext)) return 'mdi-file-excel-box';
      return 'mdi-file-document-outline';
    },
    meta() {
      if (!this.item) return '';
      const partes = [];
      if (this.item.tipo === 'video') partes.push(this.item.duracao != null ? `Vídeo · ${formatarTempo(this.item.duracao)}` : 'Vídeo');
      else if (this.item.tipo === 'imagem') partes.push('Foto');
      else partes.push(extensao(this.item.nome).toUpperCase() || 'Documento');
      if (this.item.tamanho) partes.push(formatarTamanho(this.item.tamanho));
      partes.push(this.item.servidor ? 'já enviado' : 'ainda não enviado');
      return partes.join(' · ');
    },
  },
};
</script>

<style scoped>
.ol-prev {
  overflow: hidden;
}

.ol-prev__midia {
  background: #000;
  height: 65vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ol-prev__midia--doc {
  background: #eceff1;
  height: auto;
  padding: 32px 16px;
}

.ol-prev__midia img,
.ol-prev__midia video {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.ol-prev__doc {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  text-align: center;
  color: #607d8b;
  font-size: 14px;
}

.ol-prev__titulo {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  gap: 12px;
  font-size: 1.15rem !important;
}

.ol-prev__titulo-nome {
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ol-prev__info {
  padding: 10px 16px 0;
  font-size: 13px;
  color: #78909c;
}

.ol-prev__acoes {
  padding: 8px 12px 12px;
}

.ol-prev__espaco {
  flex: 1;
}
</style>
